module.exports = __webpack_public_path__ + "static/media/5f0232d6-b8f7-4780-babe-eb4163b9484d-3.23937447.woff";